export const trackableEvents = {
  page: {
    SDP: "sdp",
    VDP: "vdp",
  },
};
